<template>
    <div class="experienceCon__menuItemCon">
        <!--小分类-->
        <div class="experienceTab--menus" v-if="subCategories && subCategories.length > 1">
            <div class="experienceTab--menuItem">
                <!--每个小分类在大分类中的数量-->

                <div class="tab--menu" v-for="(subCategory, i) in subCategories" :key="('subCategoryMenu_'+i)"
            :class="{ active: currentSubCategory==subCategory}"
            @mouseenter="onSubCategoryClick(subCategory)" v-show="getItemListBySubCategories(subCategory).length>0">
                    <p>{{subCategory}} ({{getItemListBySubCategories(subCategory).length}})</p>
                </div>
            </div>
        </div>
        <!--图片介绍-->
        <div class="experienceCon__imgIntro">
            
            <div class="experienceCon__imgCon" v-for="(subCategory, i) in subCategories" :key="('subCategoryGroup_'+i)"
            v-show="currentSubCategory==subCategory">
                <ExperienceItem 
                    class="img_container" :class="{ 'img_containerTwo': j < 2, 'img_containerThree': j >= 2}" 
                    
                    v-for="(item, j) in getItemListBySubCategories(subCategory)" :key="('item_'+item.id)"
                    :item="item"
                    :onItemClick="onItemClick"
                />
            </div>
        </div>
    </div>
</template>

<script>
const ExperienceItem = () => import('@/components/Ship/ExperienceItem')
export default {
    name: "ShipExperienceGroup",
    components: {
        ExperienceItem
    },
    props: {
        items: {
            type: Array,
            default () {
                return []
            }
        },
        subCategories: {
            type: Array,
            default () {
                return []
            }
        },
        category: {
            type: String
        },
        onItemClick: {
            type: Function
        },
        isMenuFixed: {
            type: Boolean
        },
        scrollToStart: {
            type: Function
        }
    },
    beforeMount () {
        if (this.subCategories && this.subCategories.length > 0 && this.currentSubCategory == "") {
            this.currentSubCategory = this.subCategories[0]
        }
    },
    data () {
        return {
            currentSubCategory: ""
        }
    },
    methods: {
        getItemListBySubCategories (subCategory) {
            if (subCategory == '') return this.items

            return this.items.filter(r=> r.subCategory == subCategory)
        },
        onSubCategoryClick (subCategory) {
            this.currentSubCategory = subCategory
            // this.scrollToStart()
        }
    },
    watch: {
        subCategories (newValue) {
            if (newValue && newValue.length > 0 && this.currentSubCategory == "") {
                this.currentSubCategory = newValue[0]
            }
        }
    }
}
</script>

<style lang="less" scoped>
.experienceTab--menus {
    width: 100%;
    height: 170px;
    min-width: 1024px;
    background: #fff;
    margin-top: -90px;
    padding-top: 90px;
    .experienceTab--menuItem {
        width: 59.375%;
        height: 80px;
        line-height: 80px;
        min-width: 1024px;
        margin: 0 auto;
        text-align: center;
        border-bottom: 1px solid #eaeaea;
        .tab--menu {
            margin: 0 20px;
            text-align: center;
            display: inline-block;
            height: 80px;
            line-height: 80px;
            cursor: pointer;
            p {
                font-size: 18px;
                font-weight: bold;
                color: #666666;
            }
            &.active {
                border-bottom: 3px solid #fbc300 !important;
                p {
                    color: #000f57 !important;
                }
            }
        }
    }

    
}

.experienceCon__imgIntro {
    width: 100%;
    background: #fff;
    padding-top: 32px;
    .experienceCon__imgCon {
        width: 59.375%;
        min-width: 1024px;
        margin: 0 auto;
        .img_container {
            img {
                width: 100%;
            }
            
        }
        .img_containerTwo {
            width: 49.5%;
            display: inline-block;
            // margin-right: -4px;
            position: relative;
            cursor: pointer;
            overflow: hidden;
        }
        .img_containerTwo:nth-child(2n) {
            margin-left: 0.5%;
        }
        .img_containerThree {
            width: 32.799%;
            display: inline-block;
            /* margin-right: -4px; */
            position: relative;
            margin-top: 12px;
            cursor: pointer;
            overflow: hidden;
        }
        .img_containerThree:nth-child(3n){
            margin-right: 0.5%;
        }
        .img_containerThree:nth-child(3n+2){
            margin-left:0.5%;
        }
    }
}
</style>
